export const EmptyStateIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="56"
      height="49"
      viewBox="0 0 56 49"
      fill="none"
    >
      <path
        d="M20.7885 7.01888L49.5494 9.03003C52.3286 9.22437 54.4244 11.6353 54.2301 14.4146L52.2189 43.1754C52.0246 45.9546 49.6136 48.0505 46.8344 47.8561L18.0735 45.845C15.2943 45.6506 13.1985 43.2397 13.3928 40.4604L15.404 11.6996C15.5983 8.92035 18.0093 6.82453 20.7885 7.01888Z"
        fill="#D9D9D9"
        stroke="white"
      />
      <path
        d="M5.56629 9.01775L34.3271 7.0066C37.1064 6.81225 39.5173 8.90807 39.7117 11.6873L41.7228 40.4481C41.9172 43.2274 39.8213 45.6383 37.0421 45.8327L8.28128 47.8438C5.50203 48.0382 3.09107 45.9424 2.89673 43.1631L0.885576 14.4023C0.691233 11.6231 2.78705 9.21209 5.56629 9.01775Z"
        fill="#D9D9D9"
        stroke="white"
      />
      <path
        d="M10.9189 0.5H44.1855C46.9716 0.5 49.2305 2.75889 49.2305 5.54492V38.8115C49.2305 41.5976 46.9716 43.8564 44.1855 43.8564H10.9189C8.13291 43.8564 5.87402 41.5976 5.87402 38.8115V5.54492C5.87402 2.75889 8.13291 0.5 10.9189 0.5Z"
        fill="#F0F0F0"
        stroke="white"
      />
    </svg>
  );
};
